import { render, staticRenderFns } from "./ResendHistoryTable.vue?vue&type=template&id=50a4dacb&scoped=true&lang=pug"
import script from "./ResendHistoryTable.vue?vue&type=script&lang=ts"
export * from "./ResendHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./ResendHistoryTable.vue?vue&type=style&index=0&id=50a4dacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a4dacb",
  null
  
)

export default component.exports